import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
import _imports_0 from '@/assets/images/global/close_icon.png';
var _hoisted_1 = {
  "class": "confirmDialog_page"
};
var _hoisted_2 = {
  "class": "popup_content"
};
var _hoisted_3 = {
  key: 0,
  "class": "dialog_title"
};
var _hoisted_4 = ["innerHTML"];
var _hoisted_5 = {
  "class": "dialog_btns"
};
import { reactive } from "vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title: {
      type: String,
      "default": ""
    },
    message: {
      type: String,
      "default": ""
    },
    cancelText: {
      type: String,
      "default": "取消"
    },
    showCancelBtn: {
      type: Boolean,
      "default": true
    },
    sureText: {
      type: String,
      "default": "确定"
    },
    showSureBtn: {
      type: Boolean,
      "default": true
    },
    showClose: {
      type: Boolean,
      "default": true
    }
  },
  emits: ["closeDialog", "sureEvent", "cancelEvent"],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var state = reactive({
      show: false,
      title: props.title || "",
      message: props.message || "",
      cancelText: props.cancelText || "取消",
      sureText: props.sureText || "确定",
      showSureBtn: props.showSureBtn || true,
      showCancelBtn: props.showCancelBtn || true
    });
    var open = function open() {
      state.show = true;
    };
    var close = function close() {
      state.show = false;
    };
    var closeBtn = function closeBtn() {
      emits("closeDialog");
    };
    var doCancel = function doCancel() {
      emits("cancelEvent");
    };
    var doSure = function doSure() {
      emits("sureEvent");
    };
    __expose({
      open: open,
      close: close
    });
    return function (_ctx, _cache) {
      var _component_van_button = _resolveComponent("van-button");
      var _component_van_overlay = _resolveComponent("van-overlay");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_overlay, {
        show: state.show,
        "lock-scroll": false,
        "z-index": "2"
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [state.title ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_renderSlot(_ctx.$slots, "leftIcon"), _createTextVNode(" " + _toDisplayString(state.title), 1 /* TEXT */)])) : _createCommentVNode("v-if", true), props.message ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            "class": _normalizeClass(["dialog_message", state.title ? '' : 'no_title_message']),
            innerHTML: props.message || state.message
          }, null, 10 /* CLASS, PROPS */, _hoisted_4)) : (_openBlock(), _createElementBlock("div", {
            key: 2,
            "class": _normalizeClass(["dialog_message", state.title ? '' : 'no_title_message'])
          }, [_renderSlot(_ctx.$slots, "message")], 2 /* CLASS */)), _createElementVNode("div", _hoisted_5, [state.showCancelBtn ? (_openBlock(), _createBlock(_component_van_button, {
            key: 0,
            round: "",
            "class": "cancel_btn",
            onClick: doCancel
          }, {
            "default": _withCtx(function () {
              return [_createTextVNode(_toDisplayString(state.cancelText), 1 /* TEXT */)];
            }),
            _: 1 /* STABLE */
          })) : _createCommentVNode("v-if", true), state.showSureBtn ? (_openBlock(), _createBlock(_component_van_button, {
            key: 1,
            round: "",
            "class": "sure_btn",
            onClick: doSure
          }, {
            "default": _withCtx(function () {
              return [_createTextVNode(_toDisplayString(state.sureText), 1 /* TEXT */)];
            }),
            _: 1 /* STABLE */
          })) : _createCommentVNode("v-if", true)]), __props.showClose ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            "class": "dialog_close",
            onClick: closeBtn
          }, _cache[0] || (_cache[0] = [_createElementVNode("img", {
            src: _imports_0,
            alt: ""
          }, null, -1 /* HOISTED */)]))) : _createCommentVNode("v-if", true)])];
        }),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["show"])]);
    };
  }
});